import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Career } from '../models/career/career';

@Injectable({ providedIn: 'root' })
export class CurrentCareerService {
	public currentCareer: BehaviorSubject<Career | null>;
	public currentCareerId: BehaviorSubject<string | null>;

	constructor() {
		this.currentCareer = new BehaviorSubject<Career | null>(null);
		this.currentCareerId = new BehaviorSubject<string | null>(null);
	}

	changeActiveCareer(career: Career) {
		sessionStorage.setItem('career', career.id);
		this.currentCareerId.next(career.id);
		this.currentCareer.next(career);
	}

	getCareerFromStorage(): string | null {
		return sessionStorage.getItem('career');
	}

	exitActiveCareer() {
		sessionStorage.removeItem('career');
		this.currentCareer.next(null);
		this.currentCareerId.next(null);
	}

	/**
	 * Checks if a career is considered closed.
	 * A career is closed if logbook_closed is active OR if a closing_date is set.
	 */
	public isCareerClosed(career: Career): boolean {
		if (!career) return false;
		return career.logbook_closed === true || career.closing_date !== null;
	}
}
